import React from 'react'
import { loadStripe } from '@stripe/stripe-js';
import {
    PaymentElement,
    Elements,
    CardElement,
} from '@stripe/react-stripe-js';
import CheckoutForm from './CheckoutForm';
import config from '../../config';

const StripeContainer = () => {

    const stripePayment = loadStripe(config.stripKey)

    return (
        <div>
            <Elements stripe={stripePayment}>
                <CheckoutForm />
            </Elements>
        </div>
    )
}

export default StripeContainer